import { render, staticRenderFns } from "./RenewPage.vue?vue&type=template&id=a400ad34&scoped=true&"
import script from "./RenewPage.vue?vue&type=script&lang=js&"
export * from "./RenewPage.vue?vue&type=script&lang=js&"
import style0 from "./RenewPage.vue?vue&type=style&index=0&id=a400ad34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a400ad34",
  null
  
)

export default component.exports